import React from 'react';
import smartlookClient from 'smartlook-client';

const Smartlook = () => {
  const [initialized, setInitialized] = React.useState(false);

  const getCookie = (name) => {
    const cookieArr = document.cookie.split(';');
    let cookiePair;
    let cookieForOptanon = null;

    cookieArr.forEach((cookie) => {
      cookiePair = cookie.split('=');
      if (name === cookiePair[0].trim()) {
        let cookieValue = cookiePair.find((c) => {
          return c.includes('C000');
        });
        cookieForOptanon = decodeURIComponent(cookieValue);
      }
    });
    return cookieForOptanon;
  };

  React.useEffect(() => {
    const InitSmartlook = () => {
      try {
        const cookie = getCookie('OptanonConsent');
        let performanceCookieValue;
        let recordScriptFlag;

        if (cookie !== null) {
          cookie
            .split('&')[0]
            .split(',')
            .forEach((element) => {
              if (element.includes('C0002')) {
                performanceCookieValue = element.split(':');
              }
            });
          if (performanceCookieValue && performanceCookieValue[1] == 1) {
            recordScriptFlag = true;
          } else {
            recordScriptFlag = false;
          }
        } else {
          recordScriptFlag = false;
        }

        if (!smartlookClient.initialized() && recordScriptFlag) {
          smartlookClient.init(import.meta.env.VITE_SMARTLOOK_APPID, {
            packAssets: true,
            region: 'eu',
            cookies: true,
            injectCSSRules: true,
          });
          smartlookClient.anonymize();
          setInitialized(true);
        } else if (!recordScriptFlag) {
          smartlookClient.disable(true);
          setInitialized(true);
        }
      } catch (error) {
        // eslint-disable-next-line
        console.warn('Smartlook initialization failed:', error);
        setInitialized(true); // Mark as initialized even on error to prevent blocking
      }
    };

    InitSmartlook();
  }, []);

  return null;
};

// Safe wrapper functions
const navigation = (page) => {
  try {
    if (
      smartlookClient &&
      smartlookClient.initialized &&
      smartlookClient.initialized()
    ) {
      smartlookClient.navigation(page);
    }
  } catch (error) {
    // Silently fail - don't break the app
  }
};

const track = (eventName, properties) => {
  try {
    if (
      smartlookClient &&
      smartlookClient.initialized &&
      smartlookClient.initialized()
    ) {
      smartlookClient.track(eventName, properties);
    }
  } catch (error) {
    // Silently fail
  }
};

const identify = (userId, props) => {
  try {
    if (
      smartlookClient &&
      smartlookClient.initialized &&
      smartlookClient.initialized()
    ) {
      smartlookClient.identify(userId, props);
    }
  } catch (error) {
    // Silently fail
  }
};

// Attach methods to the component function
Smartlook.navigation = navigation;
Smartlook.track = track;
Smartlook.identify = identify;

// Export default component with methods attached
export default Smartlook;

// Also export named exports for flexibility
export {navigation, track, identify};
